module.exports = "<div>\r\n    <form class=\"ng-class:{ 'gw-submitted': confirmationForm.submitted }\" novalidate name=\"confirmationForm\">\r\n\r\n        <div class=\"gw-page-section-title gw-page-section-title__area gw-as-page-title\">\r\n            <div class=\"gw-page-section-title__left\">{{'quoteandbind.wc.views.confirmation.Confirmation'|translate}}</div>\r\n        </div>\r\n\r\n        <div gw-wizard-page-actions></div>\r\n    </form>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/wc/views/wc-confirmation.html
// module id = 510
// module chunks = 0